import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ setProtectedRouteError }) => {
  const { currentUser, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    setProtectedRouteError(true);
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;